import { Factory } from 'miragejs'

export default Factory.extend({
  readingCleverShared() {
    return false
  },
  mathsCleverShared() {
    return false
  },
  readingCleverManaged() {
    return false
  },
  mathsCleverManaged() {
    return false
  },
  cleverId(i) {
    return `clever_id_${i}`
  },
})
